import { Validation, ValidationResult } from "./Validation";

/**
 * Ein einzelnes Bild für eine Gegenstandbeschreibung.
 */
export default interface ItemImageJson {
    ID: number | null;

    /**
     * Alt-Text (Bildbeschreibung) für Barrierefreiheit.
     */
    altText: string;

    /**
     * Bild als Data-URL (oder Link zum Bild). Maximalgröße 10 MB für DataURLs.
     */
    url: string;
}

export let dataUrlJpegPrefix = "data:image/jpeg;base64,";
export let imageDataUrlMaxLength = dataUrlJpegPrefix.length + (1024 * 1024 * 10 * 8 / 6); // 22 Zeichen Data URL Start, Limit 10 Megabyte, 6 bits pro Zeichen

export function validateItemImageJson(json: ItemImageJson): ValidationResult<ItemImageJson> {
    return new Validation(json)
        .validateInteger("ID", 0, null, true)
        .validateString("altText", 500)
        .validateString("url", imageDataUrlMaxLength)
        .finish();
}
export function validateItemImageJsonAdd(json: ItemImageJson): ValidationResult<ItemImageJson> {
    return new Validation(json)
        .validateEquals("ID", null)
        .validateString("altText", 500)
        .validateString("url", imageDataUrlMaxLength)
        .finish();
}